import {create} from 'zustand';
import type {VelaCartFacts} from '../engine/types';

type VelaCartStore = VelaCartFacts & {
  setCart: (state: VelaCartFacts) => void;
};

export const EMPTY_VELA_CART: VelaCartFacts = {
  hasHolds: false,
  hasAuthorisations: false,
  hasPayLater: false,
};

export const useVelaCartStore = create<VelaCartStore>(set => ({
  ...EMPTY_VELA_CART,
  setCart: state => set(state),
}));
